/** Takes a dict {"foo": "xyz", "bar": "abc"} and returns a string ?foo=xyz&bar=abc */
export function makeQueryParams(params: {
  [key: string]: string | number | null | undefined;
}): string {
  const paramsFiltered: { [key: string]: string } = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
      paramsFiltered[key] = String(value);
    }
  }
  if (Object.keys(paramsFiltered).length > 0) {
    return "?" + new URLSearchParams(paramsFiltered).toString();
  } else {
    return "";
  }
}

/** Sanitize the ?next=xyz parameter to protect against the 'open redirect' security vulnerability. */
export function sanitizeNextParam(next: string | null): string | null {
  if (next === null) {
    return next;
  }

  // These trusted hosts are the only hosts our frontend should redirect to.
  // If we need to integrate with a new third-party add their host(s) here as trusted.
  const trustedHosts: Array<string> = [
    "datadoghq.com",
    "datadoghq.eu",
    "ddog-gov.com",
    "github.com",
    "localhost",
    "modal.com",
    "modal-dev.com",
    "stripe.com",
  ];
  const fallbackNext = "/home";

  // Bad redirect. a backend server (e.g. sanic) may redirect this to a different host.
  // e.g. //google.com -> https://google.com.
  if (next.startsWith("//")) {
    return fallbackNext;
  } else if (next.startsWith("/")) {
    // Relative URL; OK.
    return next;
  }

  try {
    const url = new URL(next);
    for (let i = 0; i < trustedHosts.length; i++) {
      const host = trustedHosts[i];
      // exact match or subdomain (e.g foo.stripe.com is valid)
      if (url.hostname == host || url.hostname.endsWith(`.${host}`)) {
        return next; // matches trusted host.
      }
    }

    return fallbackNext;
  } catch (_) {
    // Invalid URL
    return fallbackNext;
  }
}
